import React from 'react';
import {Redirect} from 'react-router-dom';

import StorageUtils from '../utils/storage';

const getComponent = ({PageContainer, Component, routeProps, finalNavBarList}) => {
  const pageContainerProps = finalNavBarList ? {...routeProps, finalNavBarList} : {...routeProps};

  return (
    <PageContainer {...pageContainerProps}>
      <Component {...routeProps} />
    </PageContainer>
  );
};

function withProtectRoute({
  PageContainer,
  Component,
  componentProps,
  showRoute,
  redirect = {},
  isProtected = true,
  isAuthenticated,
  finalNavBarList,
}) {
  isAuthenticated = isAuthenticated || StorageUtils.getUser()?.isAuthenticated;
  return function (props) {
    let redirectUrl = null;

    if (isProtected) {
      if (isAuthenticated) {
        if (showRoute) {
          return getComponent({
            PageContainer,
            Component,
            routeProps: {...props, ...componentProps},
            finalNavBarList,
          });
        } else {
          redirectUrl = redirect.HOME;
        }
      } else {
        redirectUrl = redirect.LOGIN;
      }
    } else {
      if (!isAuthenticated) {
        return getComponent({
          PageContainer,
          Component,
          routeProps: {...props, ...componentProps},
          finalNavBarList,
        });
      } else {
        redirectUrl = redirect.HOME;
      }
    }
    return <Redirect to={redirectUrl} />;
  };
}

export default withProtectRoute;
